module.exports = __webpack_public_path__ + "img/zql.d29f5de9.jpg";